<template>
    <ModalBase
        title="¿Quieres liberar el asiento?"
        name="liberarAsiento"
        @close="close(false)"
    >
        <div class="tw:text-center tw:py-4">
            <p class="tw:text-gray-600 tw:mb-6" v-if="evento">
                <strong>{{ evento.name }}</strong> — {{ sesion?.fecha }} {{ sesion?.hora }}
            </p>
            <p class="tw:text-gray-600 tw:mb-6" v-else>
                Esta acción liberará el asiento para el evento y sesión seleccionados.
            </p>

            <Button
                :loading="loading"
                :disabled="loading"
                variant="danger"
                @click="liberar"
            >
                {{ loading ? 'Liberando...' : 'SI, liberar asiento' }}
            </Button>
        </div>
    </ModalBase>
</template>

<script setup>
    import { ref } from 'vue';
    import store from '@/store';
    import { config } from '@/config';
    import { useToast } from '@/composables/common/useToast';
    import ModalBase from '@/modules/admin/ui/ModalBase.vue';
    import Button from '@/modules/admin/ui/Button.vue';

    const props = defineProps({
        abonado_id: { type: [String, Number], required: true },
        evento: { type: Object, default: null },
        sesion: { type: Object, default: null },
    });

    const emit = defineEmits(['close']);
    const toast = useToast();

    const loading = ref(false);

    function close(actualizar = false) {
        emit('close', 'liberarAsiento', actualizar);
    }

    async function liberar() {
        if (loading.value) return;
        loading.value = true;

        try {
            const params = {
                filters: {},
                evento_id: props.evento?.id,
                sesion_id: props.sesion?.id,
                abonado_id: props.abonado_id,
            };

            const res = await store.dispatch(
                config.getVuexAlias('back.abonados.liberar.asientos'),
                params,
            );

            const mensaje = res.data.message?.message || 'Asiento liberado correctamente';
            toast.success(mensaje);
            close(true);
        } catch (err) {
            const mensaje = err.response?.data?.message?.error || 'Error al liberar el asiento';
            toast.error(mensaje);
            close(false);
        } finally {
            loading.value = false;
        }
    }
</script>
